<div class="slide-prestation" [ngStyle]="{'width': '100%'}" (click)="findCalendar($event);">
    <div id="slide-left" *ngIf="showLeft">
        <div style="padding-left: 70px;">
            <div class="title-presatation" style='font-size:20px'> Dépôt/Prestation pour
                {{ newprest && newprest.artDepot ? (newprest.artDepot.code + ' / ' + newprest.artDepot.libelle) : '' }}
            </div>
        </div>
        <div class="col-sm-12" style="height:calc(100% - 70px)">
            <div class="col-sm-1" style="padding:5px;" *ngIf="!isModifierLeContenant"
                [ngStyle]="{'margin-top': getMargin()}">
                <ul style="padding-left:0px;">
                    <li [ngClass]="{'step-active':step===1, 'step-oval':step!==1}"
                        [ngStyle]="{'background-color':step > 1 ? '#e7e7e7' : '' }">
                        {{step===1 ? '1' : ''}} </li>
                    <li [ngClass]="{'step-active':step===2, 'step-oval':step!==2}"
                        [ngStyle]="{'background-color':step > 2 ? '#e7e7e7' : '' }">
                        {{step===2 ? '2' : ''}} </li>
                    <li [ngClass]="{'step-active':step===3, 'step-oval':step!==3}"
                        [ngStyle]="{'background-color':step > 3 ? '#e7e7e7' : '' }">
                        {{step===3 ? '3' : ''}} </li>
                    <li [ngClass]="{'step-active':step===4, 'step-oval':step!==4}"
                        [ngStyle]="{'background-color':step > 4 ? '#e7e7e7' : '' }">
                        {{step===4 ? '4' : ''}} </li>
                    <li [ngClass]="{'step-active':step===5, 'step-oval':step!==5}"
                        [ngStyle]="{'background-color':step > 5 ? '#e7e7e7' : '' }">
                        {{step===5 ? '5' : ''}} </li>
                    <li [ngClass]="{'step-active':step===6, 'step-oval':step!==6}"
                        [ngStyle]="{'background-color':step > 6 ? '#e7e7e7' : '' }">
                        {{step===6 ? '6' : ''}} </li>
                    <li [ngClass]="{'step-active':step===7, 'step-oval':step!==7}"
                        [ngStyle]="{'background-color':step > 7 ? '#e7e7e7' : '' }">
                        {{step===7 ? '7' : ''}} </li>

                    <li [ngClass]="{'step-active':step===8, 'step-oval':step!==8}"
                        [ngStyle]="{'background-color':step > 8 ? '#e7e7e7' : '' }">
                        {{step===8 ? '7' : ''}} </li>
                    <li [ngClass]="{'step-active':step===8.1, 'step-oval':step!==8.1}"
                        [ngStyle]="{'background-color':step > 8.1 ? '#e7e7e7' : '' }">
                        {{step===8.1 ? '8' : ''}} </li>
                    <li [ngClass]="{'step-active':step===9, 'step-oval':step!==9}"
                        [ngStyle]="{'background-color':step > 9 ? '#e7e7e7' : '' }">
                        {{step===9 ? '8' : ''}} </li>
                    <li [ngClass]="{'step-active':step===10, 'step-oval':step!==10}"
                        [ngStyle]="{'background-color':step > 10 ? '#e7e7e7' : '' }">
                        {{step===10 ? (isShowSite ? '9' : '8') : ''}} </li>
                    <li [ngClass]="{'step-active':step===11, 'step-oval':step!==11}"
                        [ngStyle]="{'background-color':step > 11 ? '#e7e7e7' : '' }">
                        {{step===11 ? (isShowSite ? '10' : '9') : ''}} </li>

                </ul>
            </div>
            <div class="col-sm-1" style="padding:5px;" *ngIf="isModifierLeContenant"
                [ngStyle]="{'margin-top': '-73px'}">
                <ul style="padding-left:0px;">
                    <li [ngClass]="{'step-active':step===1, 'step-oval':step!==1}"
                        [ngStyle]="{'background-color':step > 1 ? '#e7e7e7' : '' }">
                        {{step===1 ? '1' : ''}} </li>
                    <li [ngClass]="{'step-active':step===2, 'step-oval':step!==2}"
                        [ngStyle]="{'background-color':step > 2 ? '#e7e7e7' : '' }">
                        {{step===2 ? '2' : ''}} </li>
                    <li [ngClass]="{'step-active':step===3, 'step-oval':step!==3}"
                        [ngStyle]="{'background-color':step > 3 ? '#e7e7e7' : '' }">
                        {{step===3 ? '3' : ''}} </li>
                    <li [ngClass]="{'step-active':step===4, 'step-oval':step!==4}"
                        [ngStyle]="{'background-color':step > 4 ? '#e7e7e7' : '' }">
                        {{step===4 ? '4' : ''}} </li>
                    <li [ngClass]="{'step-active':step===5, 'step-oval':step!==5}"
                        [ngStyle]="{'background-color':step > 5 ? '#e7e7e7' : '' }">
                        {{step===5 ? '5' : ''}} </li>
                    <li [ngClass]="{'step-active':step===6, 'step-oval':step!==6}"
                        [ngStyle]="{'background-color':step > 6 ? '#e7e7e7' : '' }">
                        {{step===6 ? '6' : ''}} </li>
                    <li [ngClass]="{'step-active':step===7, 'step-oval':step!==7}"
                        [ngStyle]="{'background-color':step > 7 ? '#e7e7e7' : '' }">
                        {{step===7 ? '5' : ''}} </li>

                    <li [ngClass]="{'step-active':step===8, 'step-oval':step!==8}"
                        [ngStyle]="{'background-color':step > 8 ? '#e7e7e7' : '' }">
                        {{step===8 ? '7' : ''}} </li>
                    <!-- <li [ngClass]="{'step-active':step===8.1, 'step-oval':step!==8.1}"
                        [ngStyle]="{'background-color':step > 8.1 ? '#e7e7e7' : '' }">
                        {{step===8.1 ? '9' : ''}} </li> -->
                    <li [ngClass]="{'step-active':step===9, 'step-oval':step!==9}"
                        [ngStyle]="{'background-color':step > 9 ? '#e7e7e7' : '' }">
                        {{step===9 ? '8' : ''}} </li>
                    <li [ngClass]="{'step-active':step===10, 'step-oval':step!==10}"
                        [ngStyle]="{'background-color':step > 10 ? '#e7e7e7' : '' }">
                        {{step===10 ? (isShowSite ? '10' : '9') : ''}} </li>
                    <li [ngClass]="{'step-active':step===11, 'step-oval':step!==11}"
                        [ngStyle]="{'background-color':step > 11 ? '#e7e7e7' : '' }">
                        {{step===11 ? (isShowSite ? '11' : '10') : ''}} </li>

                </ul>
            </div>
            <div class="col-sm-11" style="height:100%;">
                <div class="text-left uppercase btn-nav" *ngIf="!edit && !isModifierLeContenant" (click)="prevStep()">
                    <img src="assets/images/icons/fleche-precedent.svg" alt="precedent" /> Précédent
                </div>
                <div class="add-prestation" *ngIf="!isModifierLeContenant" [ngSwitch]="step">
                    <div class="col-sm-12" style="padding: 5px; height:100%">
                        <div *ngSwitchCase="1" class="etape1">
                            <div style="margin-bottom: 20px">
                                <span class="step-title">Recherchez le client</span>
                            </div>
                            <div class="form-group">
                                <app-autocomplete *ngIf="!newprest.showcombo"
                                    [placeholder]="'Nom et prénom du client *'" (searchfunction)="searchClient($event)"
                                    (selectfunction)="setValue($event, 'client');" [defaultselected]="newprest.client"
                                    [results]="dataClient" [label]="'Nom et prénom du client *'"
                                    [defaultsearch]="newprest.client ? (newprest.client.libelleObjetEntite || '') : ''"
                                    [minlength]="3" [active]='true'></app-autocomplete>
                            </div>

                            <div class="uppercase" [ngStyle]="{'margin': newprest.showcombo ? '20px 0px' : '80px 0px'}">
                                <button class="btn-ok"
                                    (click)="newprest.client ? nextStep() : setValue($event, 'client')">
                                    OK </button>
                                <label>Appuyez sur
                                    <b>Entrée</b> pour valider.</label>
                            </div>
                        </div>
                        <div *ngSwitchCase="2" class="etape2">
                            <div style="margin-bottom: 15px">
                                <span class="step-title">Sélectionnez le chantier</span>
                            </div>
                            <div class="form-group">
                                <app-autocomplete [placeholder]="'Chantier *'" (searchfunction)="searchChantier($event)"
                                    (selectfunction)=" selectedChantier = $event;setValue($event, 'chantier');"
                                    [defaultselected]="newprest.chantier" [results]="listChantier"
                                    [label]="'Chantier *'"
                                    [defaultsearch]="newprest.chantier ? newprest.chantier.numChantier : ''"
                                    [autoshow]="false" [active]='true'></app-autocomplete>
                            </div>

                            <!--
                            <label class="text" style=" margin-top: 190px;padding-left: 0px;"
                                (click)="getChantier(false)">Voulez-vous
                                <span class='text-underline uppercase'>creer un chantier</span> ?</label>
                            -->

                            <div class="uppercase" style="margin: 80px 0px;;">
                                <button class="btn-ok" (click)="setValue(selectedChantier, 'chantier')">
                                    OK </button>
                                <label>Appuyez sur
                                    <b>Entrée</b> pour valider.</label>
                            </div>
                        </div>
                        <div *ngSwitchCase="3" class="etape3">
                            <div style="margin-bottom: 15px">
                                <span class="step-title"> Vérifier l'adresse du chantier </span>
                            </div>
                            <div class="list-group">
                                <li class="list-group-item container selected-item" id="autofocus" tabindex="0"
                                    *ngIf="selectedChantier" (keyup.enter)="setValue('test', 'adresse')"
                                    style="height: auto;">
                                    <input type="radio" class="col-sm-1" name="adresse" checked="checked" value="item">
                                    <span class="col-sm-12">
                                        <div> {{selectedChantier.numChantier || ''}} </div>
                                        <div> {{selectedChantier.adresse1 || ''}} </div>
                                        <div> {{selectedChantier.adresse2 || ''}} </div>
                                        <div> {{selectedChantier.adresse3 || ''}} </div>
                                        <div> {{ (selectedChantier.codePostal || '') +' '+ (selectedChantier.ville ||
                                            '') }} </div>
                                        <div> {{ (selectedChantier.telephone || '') }} </div>
                                    </span>
                                </li>
                            </div>
                            <div class="uppercase" style="margin: 80px 0px;">
                                <button class="btn-ok" (click)="setValue('test', 'adresse')">
                                    OK </button>
                                <label>Appuyez sur
                                    <b>Entrée</b> pour valider.</label>
                            </div>
                        </div>
                        <div *ngSwitchCase="4" class="etape2">
                            <div style="margin-bottom: 15px">
                                <span class="step-title">Choix de la date et de l'heure</span>
                            </div>
                            <div class="form-group col-sm-12" style="padding: 0">
                                <div class="col-sm-12" style="padding: 0">
                                    

                                    <span class="col-sm-12" style="padding: 0"> Date :
                                        <span style="margin-left: 147px;">{{common.isDate(newprest.dateStart)}}</span>
                                      </span>
                                      <div class="col-sm-12 form-group" style="padding: 0">
                                        <app-input-date [closeDatepickerOnSelect]="true" [class]="'col-sm-12 date'" [id]="'date1'"
                                                        [model]="newprest.dateStart"
                                                        (changefct)="newprest.dateStart = $event; changeDateStart($event); showDate = true;  newBenne.dateDebutLoc = $event"
                                                        [placeholder]="'Date debut'"
                                                        (keyenterfct)="common.changeDate($event, newprest.dateStart, '#h1'); common.changeDate($event, newBenne.dateDebutLoc)"
                                                        (selectfct)="selectDate($event, '#date1')" [showDatepicker]="true">
                                        </app-input-date>
                                      </div>
                                      <ng-template [ngIf]="societe.gestionDateMax ">
                                        <span class="col-sm-12" style="padding: 0"> Date Max :
                                          <span style="margin-left: 147px;">{{common.isDate(newprest.dateMaxStart)}}</span>
                                        </span>
                                        <div class="col-sm-12 form-group" style="padding: 0">
                                          <app-input-date [closeDatepickerOnSelect]="true" [class]="'col-sm-12 date'" [id]="'date2'"
                                                          [model]="newprest.dateMaxStart"
                                                          (changefct)="newprest.dateMaxStart = $event;"
                                                          [placeholder]="'Date Max'"
                                                          (keyenterfct)="common.changeDate($event, newprest.dateMaxStart, '#h1');"
                                                          (selectfct)="selectDate($event, '#date1')" [showDatepicker]="true">
                                          </app-input-date>
                                        </div>
                                      </ng-template>
                                    <span class="col-sm-12" style="padding: 0"> Heure : </span>
                                    <!-- <div class="col-sm-12" style="padding: 0">
                                        <input type="text" class="col-sm-6 inputtime inputLeft50" id="h1" placeholder="HH"
                                            [(ngModel)]="newprest.hour" [onReturn] autocomplete="off">

                                        <input type="text" class="inputtime col-sm-6 inputRight50" placeholder="MM"
                                            [(ngModel)]="newprest.min" autocomplete="off"
                                            (keydown.enter)=" showDate = true; setValue(true, 'showdate')">
                                    </div> -->

                                    <div class="col-sm-12 form-group" style="padding: 0">
                                      <input type="text" class="col-sm-12 inputtime" id="h1" placeholder="Heure"
                                        [(ngModel)]="newprest.hour" (keydown.enter)="showDate = true;setValue(true, 'showdate');"
                                        autocomplete="off">
                                    </div>
                                </div>
                            </div>

                            <div class="form-group col-sm-12" style="padding: 0; margin-bottom: 15px;">
                                <input type="checkbox" id="checkbox-1-1 "
                                    class="regular-checkbox regular-checkbox-checked" [(ngModel)]="newprest.program"
                                    (ngModelChange)="changeProgram();">
                                <span (click)="newprest.program = !newprest.program; changeProgram();"
                                    style="cursor: pointer;">
                                    Prestation programmée </span>
                            </div>
                            <label class="text form-group " *ngIf="newprest.program" style="padding-left: 0px;"
                                (click)="showProgrammation()">
                                <span class='text-underline uppercase'> Définir les paramètres </span></label>

                            <div class="form-group col-sm-12" style="padding: 0; margin-bottom: 15px;">
                                <input type="checkbox" id="checkbox-1-1 "
                                    class="regular-checkbox regular-checkbox-checked" [(ngModel)]="newprest.mouvSupp"
                                    (ngModelChange)="changeProgram();">
                                <span (click)="newprest.mouvSupp = !newprest.mouvSupp; changeProgram();"
                                    style="cursor: pointer;">
                                    Mouvements supplémentaires </span>
                            </div>
                            <label class="text form-group " *ngIf="newprest.mouvSupp" style="padding-left: 0px;" (click)="showMouvPlus()">
                                <span class='text-underline uppercase'> Voir les mouvements supplémentaires </span></label>
                            <div class="form-group col-sm-12" style="padding: 0; margin-bottom: 15px;">
                                <input type="checkbox" id="checkbox-1-1 "
                                    class="regular-checkbox regular-checkbox-checked" [(ngModel)]="newprest.auplustard">
                                <span (click)="newprest.auplustard = !newprest.auplustard; " style="cursor: pointer;">
                                    Au plus tard </span>
                            </div>

                            <div class="uppercase col-sm-12" style="margin: 80px 0px 0px;padding: 0;">
                                <button class="btn-ok" (click)="setValue(true, 'showdate'); showDate = true;">
                                    OK </button>
                                <label>Appuyez sur
                                    <b>Entrée</b> pour valider.</label>
                            </div>
                        </div>
                        
                        <div *ngSwitchCase="5" class="etape4 choixContenant" style="height:100%">
                            <div *ngIf="!isGroupe" style="    height: 100%;">
                                <div style="margin-bottom: 15px">
                                    <span class="step-title">Contenant </span>
                                </div>

                                <div *ngIf="newprest.newContenant && !addArticle"
                                    style="height: calc(100% - 45px); overflow-y: auto;">
                                    <div class="col-sm-12" style="padding: 0;">
                                        <div class="form-group">
                                            <span>{{ newprest.typeContenant.famille.libelle + ' ' +
                                                newprest.typeContenant.cubage.cubage +
                                                newprest.typeContenant.uniteCont.libelle }}</span>
                                        </div>
                                        <div class="form-group" *ngIf="!newBenne.isGroupeArticle">
                                            <app-autocomplete [placeholder]="'Article'" id="articleCont"
                                                (searchfunction)="searchArticle($event)" [container]="true"
                                                (selectfunction)="newBenne.art = $event; common.focusElement('#qteContenant') "
                                                [results]="listArticle" [label]="'Article'"
                                                [defaultselected]="newBenne.art"
                                                (keyenterfunction)=" setValue(newBenne, 'newBenne')"
                                                [defaultsearch]="newBenne.art ? newBenne.art.libelleObjetEntite : ''">
                                            </app-autocomplete>
                                        </div>

                                        <div class="form-group">
                                            <input type="checkbox" id="checkbox-1-1 "
                                                class="regular-checkbox regular-checkbox-checked"
                                                [(ngModel)]="newBenne.isGroupeArticle"
                                                (ngModelChange)="newBenne.art = {}">
                                            <span (click)="newBenne.isGroupeArticle = !newBenne.isGroupeArticle"
                                                style="cursor: pointer;">
                                                Groupe </span>
                                            <label class="text pull-right" *ngIf="newBenne.isGroupeArticle"
                                                style=" margin: 0px;padding: 0px;"
                                                (click)="showArticleGrp();addArticlesNewBenne()">
                                                <span class='text-underline uppercase'> ajouter un article
                                                </span></label>
                                        </div>


                                        <div class="list-group" *ngIf="newBenne.isGroupeArticle"
                                            style="margin-bottom: 15px">
                                            <li class="list-group-item container" id="autofocus"
                                                style="height: auto; padding: 5px 2px;"
                                                *ngFor="let item of newBenne.listArticle; let i = index;"
                                                tabindex="{{i}}">
                                                <div class="col-sm-10" style="padding: 0px 4px 0;">
                                                    <div>
                                                        {{item.art ? (item.art.libelleObjetEntite || item.art.libelle) :
                                                        ''}}
                                                    </div>
                                                    <div>
                                                        {{item.exutoire ? (item.exutoire.libelleObjetEntite ||
                                                        item.exutoire.nom) : ''}}
                                                    </div>
                                                </div>
                                                <div class="col-sm-2 text-center" style="padding: 0;">
                                                    <button class="btn-detail" style="margin: 0px 1px;"
                                                        (click)="selactedArticle = item; showArticleGrp();">
                                                        <i class="fa fa-pencil"></i>
                                                    </button>
                                                    <button class="btn-detail" style="margin: 0px 1px;"
                                                        (click)="deleteListArticles(newBenne.listArticle, item)">
                                                        <i class="fa fa-trash"></i>
                                                    </button>
                                                </div>
                                            </li>
                                        </div>

                                        <div class="form-group"
                                            *ngIf="newprest.typeContenant && newprest.typeContenant && !newprest.typeContenant.isUnitaire">
                                            <label *ngIf="info.quantite || newprest.qteContenantfocus"
                                                style="position: absolute">
                                                Quantité contenant </label>
                                            <input type="number" step="1" class="form-control info" id="qteContenant"
                                                placeholder="Quantité contenant" autofocus [(ngModel)]="info.quantite"
                                                (keyup.enter)="setValue('test', 'cont')"
                                                (focus)="newprest.qteContenantfocus = true;"
                                                (blur)="newprest.qteContenantfocus = false;" autocomplete="off">
                                        </div>
                                        <div class="form-group col-sm-6" style="padding: 0; margin-top: 15px;">
                                            <input type="checkbox" id="checkbox-1-1 "
                                                class="regular-checkbox regular-checkbox-checked"
                                                [(ngModel)]="newBenne.isLocation">
                                            <span (click)="newBenne.isLocation = !newBenne.isLocation"
                                                style="cursor: pointer;">
                                                Location </span>
                                        </div>
                                        <div class="form-group col-sm-6">
                                            <input type="text" class="col-sm-12 date" id="date2"
                                                [ngModel]="newBenne.dateDebutLoc"
                                                (ngModelChange)="newBenne.dateDebutLoc = $event;"
                                                placeholder="Date debut" ngbDatepicker NgbInputDatepicker
                                                [autoClose]="false" #d="ngbDatepicker"
                                                (click)="newBenne.isLocation ? d.open() : d.close();"
                                                (focus)="newBenne.isLocation ? d.open() : d.close();"
                                                (keydown)="setFocuscalendar($event)" [placement]="'bottom-right'"
                                                (dateSelect)="selectDate($event, '#date2')"
                                                (keydown.enter)="d.close();changeDatePlanning('dateDebutLoc');common.changeDate($event, newBenne.dateDebutLoc); setValue(newBenne, 'newBenne')"
                                                autocomplete="off" [disabled]="!newBenne.isLocation">
                                        </div>
                                        <div class="form-group col-sm-12" *ngIf="newBenne.isLocation"
                                            style="padding: 0; margin: 0;">
                                            <label class="text" style="  margin: 0;padding-left: 0px;"
                                                (click)="showFacturation()">
                                                <span class='text-underline uppercase'> Facturation </span></label>
                                        </div>
                                    </div>


                                    <div class="uppercase" style="margin: 10px 0px;">
                                        <button class="btn-ok" (click)="setValue(newBenne, 'newBenne')">
                                            OK </button>
                                        <label>Appuyez sur
                                            <b>Entrée</b> pour valider.</label>
                                    </div>
                                </div>

                                <div *ngIf="addArticle" style="height: calc(100% - 45px); overflow-y: auto;">
                                    <div class="col-sm-12" style="padding: 0;">
                                        <div class="form-group">
                                            <app-autocomplete [placeholder]="'Article'" id="articlegrp"
                                                (searchfunction)="searchArticle($event, newBenne.listArticle)"
                                                (selectfunction)="selactedArticle.art = $event;" [results]="listArticle"
                                                [label]="'Article'" [defaultselected]="selactedArticle.art"
                                                (keyenterfunction)="selactedArticle.art && selactedArticle.art.id ? common.focusElement('.exugrp') : false"
                                                [defaultsearch]="selactedArticle.art ? (selactedArticle.art.libelleObjetEntite || selactedArticle.art.libelle) : ''">

                                            </app-autocomplete>
                                        </div>
                                        <div class="form-group">
                                            <app-autocomplete [placeholder]="'Exutoire'" id="exugrp"
                                                (searchfunction)="searchExutoire($event)"
                                                (selectfunction)="selactedArticle.exutoire = $event;"
                                                [results]="listExutoire" [label]="'Exutoire'"
                                                [defaultselected]="selactedArticle.exutoire"
                                                (keyenterfunction)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')"
                                                [defaultsearch]="selactedArticle.exutoire ? (selactedArticle.exutoire.libelleObjetEntite || selactedArticle.exutoire.nom) : ''">
                                            </app-autocomplete>
                                        </div>
                                    </div>


                                    <div class="uppercase" style="margin: 10px 0px;">
                                        <button class="btn-ok"
                                            (click)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')">
                                            OK </button>
                                        <label>Appuyez sur
                                            <b>Entrée</b> pour valider.</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div *ngSwitchCase="6" class="etape3 choixContenant" style="height:100%">
                            <div style="margin-bottom: 15px">
                                <span class="step-title" *ngIf="!isEditContenant && !addArticle"> Vérifier le contenant
                                </span>
                                <span class="step-title" *ngIf="isEditContenant && !addArticle"> Modification du
                                    contenant </span>
                                <span class="step-title" *ngIf="addArticle"> Groupe d'article </span>
                            </div>
                            <div class="list-group" *ngIf="!isEditContenant && !addArticle" style="">
                                <li class="list-group-item container selected-item" id="autofocus2" tabindex="0"
                                    *ngIf="selectedChantier" (keyup.enter)="setValue('test', 'cont')"
                                    (click)="setValue('test', 'cont')" style="height: auto;">
                                    <app-contenant *ngIf="newprest.contenant" [item]="newprest.contenant"
                                        [common]="common"></app-contenant>
                                    <app-contenant *ngIf="newprest.newBenne" [item]="newprest.newBenne"
                                        [common]="common"></app-contenant>
                                </li>
                            </div>
                            <div class="col-sm-12" *ngIf="isEditContenant && !addArticle"
                                style="height: calc(100% - 95px); overflow-y: auto;padding: 0;">
                                <div *ngIf="newprest.contenant">
                                    <div class="form-group">
                                        <app-autocomplete
                                            (selectfunction)="newprest.contenant.typeContenant = $event;   common.focusElement('.articleCont')"
                                            [results]="typeContenant" [highlight]="true" [showonclick]="true"
                                            (searchfunction)="searchTypecontenantByLibelle($event)"
                                            [label]="'Type contenant'" id="typecontenant"
                                            [placeholder]="'Type contenant'"
                                            (keyenterfunction)="common.focusElement('.articleCont')"
                                            [defaultselected]="newprest.contenant.typeContenant"
                                            [defaultsearch]="newprest.contenant.typeContenant ? newprest.contenant.typeContenant.libelleObjetEntite : ''">
                                        </app-autocomplete>
                                    </div>
                                    <div class="form-group" *ngIf="!newprest.contenant.isGroupeArticle">
                                        <app-autocomplete [placeholder]="'Article'" id="articleCont"
                                            (searchfunction)="searchArticle($event)"
                                            (selectfunction)="newprest.contenant.art = $event;  common.focusElement('.articleCont');"
                                            [results]="listArticle" [label]="'Article'"
                                            (keyenterfunction)="newprest.contenant.art ?  setValue('test', 'cont')  : false"
                                            [defaultselected]="newprest.contenant.art"
                                            [defaultsearch]="newprest.contenant.art ? newprest.contenant.art.libelleObjetEntite : ''">
                                        </app-autocomplete>
                                    </div>
                                    <div class="form-group"
                                        *ngIf="newprest.typeContenant && newprest.typeContenant.typeContenant && !newprest.typeContenant.typeContenant.isUnitaire">
                                        <label *ngIf="info.quantite || newprest.qteContenantfocus"
                                            style="position: absolute">
                                            Quantité contenant </label>
                                        <input type="number" step="1" class="form-control info" id="qteContenant"
                                            placeholder="Quantité contenant" autofocus [(ngModel)]="info.quantite"
                                            (keyup.enter)="setValue('test', 'cont')"
                                            (focus)="newprest.qteContenantfocus = true;"
                                            (blur)="newprest.qteContenantfocus = false;" autocomplete="off">
                                    </div>

                                    <div class="form-group">
                                        <input type="checkbox" id="checkbox-1-1 "
                                            class="regular-checkbox regular-checkbox-checked"
                                            [(ngModel)]="newprest.contenant.isGroupeArticle"
                                            (ngModelChange)="newprest.contenant.art = {}">
                                        <span
                                            (click)="newprest.contenant.isGroupeArticle = !newprest.contenant.isGroupeArticle"
                                            style="cursor: pointer;">
                                            Groupe </span>
                                        <label class="text pull-right" *ngIf="newprest.contenant.isGroupeArticle"
                                            style=" margin: 0px;padding: 0px;"
                                            (click)="showArticleGrp(); addArticlesContenant()">
                                            <span class='text-underline uppercase'> ajouter un article
                                            </span></label>
                                    </div>

                                    <div class="list-group" *ngIf="newprest.contenant.isGroupeArticle"
                                        style="margin-bottom: 15px;">
                                        <li class="list-group-item container" id="autofocus"
                                            style="height: auto; padding: 5px 2px;"
                                            *ngFor="let item of newprest.contenant.listArticle; let i = index;"
                                            tabindex="{{i}}">

                                            <div class="col-sm-10" style="padding: 0px 4px 0;">
                                                <div>
                                                    {{item.art ? (item.art.libelleObjetEntite || item.art.libelle) :
                                                    ''}}
                                                </div>
                                                <div>
                                                    {{item.exutoire ? (item.exutoire.libelleObjetEntite ||
                                                    item.exutoire.nom) : ''}}
                                                </div>
                                            </div>
                                            <div class="col-sm-2 text-center" style="padding: 0px">
                                                <button class="btn-detail" style="margin: 0px 1px;"
                                                    (click)="selactedArticle = item; showArticleGrp();">
                                                    <i class="fa fa-pencil"></i>
                                                </button>
                                                <button class="btn-detail" style="margin: 0px 1px;"
                                                    (click)="deleteListArticles(newprest.contenant.listArticle, item)">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </div>

                                        </li>
                                    </div>


                                    <ng-template [ngIf]="societe.gestionBenneClient">
                                        <div class="form-group">
                                            <input type="checkbox" id="checkbox-1-1 "
                                                class="regular-checkbox regular-checkbox-checked"
                                                [(ngModel)]="newprest.contenant.benneClient"
                                                (ngModelChange)="newprest.contenant.mailContenant = ''">
                                            <span
                                                (click)="newprest.contenant.benneClient = !newprest.contenant.benneClient"
                                                style="cursor: pointer;">
                                                Appartient au client </span>
                                        </div>

                                    </ng-template>
                                    <div class="form-group" *ngIf="societe.mailBenneChantiers">
                                        <label *ngIf="newprest.contenant.mailContenant || newprest.mailContenantfocus"
                                            style="position: absolute">
                                            Mail </label>
                                        <input type="text" class="form-control info" id="mailContenant"
                                            placeholder="Mail" autofocus [(ngModel)]="newprest.contenant.mailContenant"
                                            (keyup.enter)="setValue('test', 'cont')"
                                            (focus)="newprest.mailContenantfocus = true;"
                                            (blur)="newprest.mailContenantfocus = false;"
                                            [ngStyle]="{'padding':  (newprest.contenant.mailContenant || newprest.mailContenantfocus) ? 'padding: 16px 10px 0 10px' : '0 10px'}"
                                            [disabled]="!newprest.contenant.benneClient" autocomplete="off">
                                    </div>
                                    <div class="form-group col-sm-6" style="padding: 0; margin-top: 15px;">
                                        <input type="checkbox" id="checkbox-1-1 "
                                            class="regular-checkbox regular-checkbox-checked"
                                            [(ngModel)]="newprest.contenant.isLocation" [disabled]="isVidage">
                                        <span (click)="newprest.contenant.isLocation = !newprest.contenant.isLocation"
                                            style="cursor: pointer;">
                                            Location </span>
                                    </div>
                                    <div class="form-group col-sm-6">
                                        <input type="text" class="col-sm-12 date" id="date"
                                            [ngModel]="newprest.contenant.dateDebutLoc"
                                            (ngModelChange)="newprest.contenant.dateDebutLoc = $event;"
                                            placeholder="Date debut"
                                            (click)="newprest.contenant.isLocation ? d.open() : d.close();"
                                            ngbDatepicker NgbInputDatepicker [autoClose]="false" #d="ngbDatepicker"
                                            (dateSelect)="selectDate($event, '#date')" [placement]="'bottom-right'"
                                            (focus)="newprest.contenant.isLocation ? d.open(): d.close();"
                                            (keydown)="setFocuscalendar($event)"
                                            (keydown.enter)="d.close();changeDatePlanning('dateDebutLoc', 'contenant');common.changeDate($event, newprest.contenant.dateDebutLoc); setValue('test', 'cont')"
                                            autocomplete="off" [disabled]="!newprest.contenant.isLocation"
                                            [disabled]="isVidage">
                                    </div>
                                    <div class="form-group col-sm-12" *ngIf="newprest.contenant.isLocation"
                                        style="padding: 0; margin: 0 0 15px;">
                                        <label class="text" style=" margin: 0;padding-left: 0px;"
                                            (click)="showFacturation()">
                                            <span class='text-underline uppercase'> Facturation </span></label>
                                    </div>
                                </div>
                                <div *ngIf="newprest.newBenne">
                                    <div class="form-group">
                                        <app-autocomplete
                                            (selectfunction)="newprest.newBenne.typeContenant = $event;  common.focusElement('#autocomplete')"
                                            [results]="typeContenant" [highlight]="true" [showonclick]="true"
                                            (searchfunction)="searchTypecontenantByLibelle($event)"
                                            [label]="'Type contenant'" id="typecontenant"
                                            [placeholder]="'Type contenant'"
                                            (keyenterfunction)="common.focusElement('.articleCont')"
                                            [defaultselected]="newprest.newBenne.typeContenant"
                                            [defaultsearch]="newprest.newBenne.typeContenant ? newprest.newBenne.typeContenant.libelleObjetEntite : ''">
                                        </app-autocomplete>
                                    </div>
                                    <div class="form-group" *ngIf="!newprest.newBenne.isGroupeArticle">
                                        <app-autocomplete [placeholder]="'Article'" id="articleCont"
                                            (searchfunction)="searchArticle($event)"
                                            (selectfunction)="newprest.newBenne.art = $event;  common.focusElement('.articleCont');"
                                            [results]="listArticle" [label]="'Article'"
                                            (keyenterfunction)="newprest.newBenne.art ? setValue('test', 'cont') : false"
                                            [defaultselected]="newprest.newBenne.art"
                                            [defaultsearch]="newprest.newBenne.art ? newprest.newBenne.art.libelleObjetEntite : ''">
                                        </app-autocomplete>
                                    </div>

                                    <div class="form-group">
                                        <input type="checkbox" id="checkbox-1-1 "
                                            class="regular-checkbox regular-checkbox-checked"
                                            [(ngModel)]="newprest.newBenne.isGroupeArticle"
                                            (ngModelChange)="newprest.newBenne.art = {}">
                                        <span
                                            (click)="newprest.newBenne.isGroupeArticle = !newprest.newBenne.isGroupeArticle"
                                            style="cursor: pointer;">
                                            Groupe </span>
                                        <label class="text pull-right" *ngIf="newprest.newBenne.isGroupeArticle"
                                            style=" margin: 0px;padding: 0px;"
                                            (click)="showArticleGrp(); addArticlesNewprest()">
                                            <span class='text-underline uppercase'> ajouter un article
                                            </span></label>
                                    </div>

                                    <div class="list-group" *ngIf="newprest.newBenne.isGroupeArticle"
                                        style="margin-bottom: 15px;">
                                        <li class="list-group-item container" id="autofocus"
                                            style="height: auto; padding: 5px 2px;"
                                            *ngFor="let item of newprest.newBenne.listArticle; let i = index;"
                                            tabindex="{{i}}">

                                            <div class="col-sm-10" style="padding: 0px 4px 0;">
                                                <div>
                                                    {{item.art ? (item.art.libelleObjetEntite || item.art.libelle) :
                                                    ''}}
                                                </div>
                                                <div>
                                                    {{item.exutoire ? (item.exutoire.libelleObjetEntite ||
                                                    item.exutoire.nom) : ''}}
                                                </div>
                                            </div>
                                            <div class="col-sm-2 text-center" style="padding: 0px;">
                                                <button class="btn-detail" style="margin: 0px 1px;"
                                                    (click)="selactedArticle = item; showArticleGrp();">
                                                    <i class="fa fa-pencil"></i>
                                                </button>
                                                <button class="btn-detail" style="margin: 0px 1px;"
                                                    (click)="deleteListArticles(newprest.newBenne.listArticle, item)">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </div>
                                        </li>
                                    </div>


                                    <ng-template [ngIf]="societe.gestionBenneClient">
                                        <div class="form-group">
                                            <input type="checkbox" id="checkbox-1-1 "
                                                class="regular-checkbox regular-checkbox-checked"
                                                [(ngModel)]="newprest.newBenne.benneClient"
                                                (ngModelChange)="newprest.newBenne.mailContenant = ''">
                                            <span
                                                (click)="newprest.newBenne.benneClient = !newprest.newBenne.benneClient"
                                                style="cursor: pointer;">
                                                Appartient au client </span>
                                        </div>

                                    </ng-template>
                                    <div class="form-group" *ngIf="societe.mailBenneChantiers">
                                        <label *ngIf="newprest.newBenne.mailContenant || newprest.mailContenantfocus"
                                            style="position: absolute">
                                            Mail </label>
                                        <input type="text" class="form-control info" id="mailContenant"
                                            placeholder="Mail" autofocus [(ngModel)]="newprest.newBenne.mailContenant"
                                            (keyup.enter)="setValue('test', 'cont')"
                                            (focus)="newprest.mailContenantfocus = true;"
                                            (blur)="newprest.mailContenantfocus = false;"
                                            [ngStyle]="{'padding':  (newprest.newBenne.mailContenant || newprest.mailContenantfocus) ? 'padding: 16px 10px 0 10px' : '0 10px'}"
                                            [disabled]="!newprest.newBenne.benneClient" autocomplete="off">
                                    </div>
                                    <div class="form-group col-sm-6" style="padding: 0; margin-top: 15px;">
                                        <input type="checkbox" id="checkbox-1-1 "
                                            class="regular-checkbox regular-checkbox-checked"
                                            [(ngModel)]="newBenne.isLocation">
                                        <span (click)="newprest.newBenne.isLocation = !newprest.newBenne.isLocation"
                                            style="cursor: pointer;">
                                            Location </span>
                                    </div>
                                    <div class="form-group col-sm-6">
                                        <input type="text" class="col-sm-12 date" id="date"
                                            [ngModel]="newprest.newBenne.dateDebutLoc"
                                            (ngModelChange)="newprest.newBenne.dateDebutLoc = $event;"
                                            placeholder="Date debut" [placement]="'bottom-right'"
                                            (click)="newprest.newBenne.isLocation ? d.open() : d.close();" ngbDatepicker
                                            NgbInputDatepicker [autoClose]="false" #d="ngbDatepicker"
                                            (dateSelect)="selectDate($event, '#date')"
                                            (focus)="newprest.newBenne.isLocation ? d.open(): d.close();"
                                            (keydown)="setFocuscalendar($event)"
                                            (keydown.enter)="d.close();changeDatePlanning('dateDebutLoc', 'newBenne');common.changeDate($event, newprest.newBenne.dateDebutLoc); setValue('test', 'cont')"
                                            autocomplete="off" [disabled]="!newprest.newBenne.isLocation">
                                    </div>
                                    <div class="form-group col-sm-12" *ngIf="newprest.newBenne.isLocation"
                                        style="padding: 0; margin: 0 0 15px;">
                                        <label class="text" style=" margin: 0px;padding-left: 0px;"
                                            (click)="showFacturation()">
                                            <span class='text-underline uppercase'> Facturation </span></label>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="addArticle" style="height: calc(100% - 45px); overflow-y: auto;">
                                <div class="col-sm-12" style="padding: 0;">
                                    <div class="form-group">
                                        <app-autocomplete [placeholder]="'Article'" id="articlegrp"
                                            (searchfunction)="searchArticle($event, newBenne.listArticle)"
                                            (selectfunction)="selactedArticle.art = $event;" [results]="listArticle"
                                            [label]="'Article'" [defaultselected]="selactedArticle.art"
                                            (keyenterfunction)="selactedArticle.art && selactedArticle.art.id ? common.focusElement('.exugrp') : false"
                                            [defaultsearch]="selactedArticle.art ? (selactedArticle.art.libelleObjetEntite || selactedArticle.art.libelle) : ''">

                                        </app-autocomplete>
                                    </div>
                                    <div class="form-group">
                                        <app-autocomplete [placeholder]="'Exutoire'" id="exugrp"
                                            (searchfunction)="searchExutoire($event)"
                                            (selectfunction)="selactedArticle.exutoire = $event;"
                                            [results]="listExutoire" [label]="'Exutoire'"
                                            [defaultselected]="selactedArticle.exutoire"
                                            (keyenterfunction)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')"
                                            [defaultsearch]="selactedArticle.exutoire ? (selactedArticle.exutoire.libelleObjetEntite || selactedArticle.exutoire.nom) : ''">
                                        </app-autocomplete>
                                    </div>
                                </div>


                                <div class="uppercase" style="margin: 10px 0px;">
                                    <button class="btn-ok"
                                        (click)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp');">
                                        OK </button>
                                    <label>Appuyez sur
                                        <b>Entrée</b> pour valider.</label>
                                </div>
                            </div>

                            <div class="uppercase" *ngIf="!addArticle" style="margin: 80px 0px;">
                                <button class="btn-ok" (click)="setValue('test', 'cont')">
                                    OK </button>
                                <label>Appuyez sur
                                    <b>Entrée</b> pour valider.</label>
                            </div>
                        </div>
                        <div *ngSwitchCase="8" class="etape2">
                            <div style="margin-bottom: 15px">
                                <span class="step-title"> Choix de l'exutoire </span>
                            </div>
                            <div class="form-group">
                                <app-autocomplete [placeholder]="'Exutoire'" (searchfunction)="searchExutoire($event)"
                                    (selectfunction)="setValue($event, 'exutoire');defaultExutoir = $event"
                                    [id]="'exutoire'" [results]="listExutoire" [label]="'Exutoire'"
                                    [defaultselected]="defaultExutoir"
                                    [defaultsearch]="defaultExutoir ? defaultExutoir.libelleObjetEntite : ''">
                                </app-autocomplete>
                            </div>

                            <div class="uppercase" style="margin: 80px 0px;;">
                                <button class="btn-ok"
                                    (click)="defaultExutoir ? setValue(defaultExutoir, 'exutoire') : false">
                                    OK </button>
                                <label>Appuyez sur
                                    <b>Entrée</b> pour valider.</label>
                            </div>
                        </div>


                        
                        <div *ngSwitchCase="9" class="etape2">
                            <div style="margin-bottom: 15px">
                                <span class="step-title">Choix du site </span>
                            </div>
                            <div class="form-group col-sm-12" style="padding: 0;">
                                <app-autocomplete [placeholder]="'site'" (searchfunction)="searchSite($event)"
                                    (selectfunction)="setValue($event, 'sitePrest'); defaultSite = $event"
                                    [results]="listeSiteCA" [highlight]="true" [label]="''"
                                    [dropdownclass]="mindropdown" [selectvalue]="true" [isCombo]="true"
                                    [id]="'sitePrest'" [defaultselected]="defaultSite"
                                    [defaultsearch]="defaultSite ? defaultSite.nom : ''"></app-autocomplete>
                            </div>

                            <div class="uppercase col-sm-12" style="margin: 80px 0px 0px;padding: 0;">
                                <button class="btn-ok" (click)="setValue(defaultSite, 'sitePrest');">
                                    OK </button>
                                <label>Appuyez sur
                                    <b>Entrée</b> pour valider.</label>
                            </div>
                        </div>
                        <div *ngSwitchCase="10" class="etape8">
                            <div style="margin-bottom: 15px">
                                <span class="step-title"> Divers </span>
                            </div>
                            <div class="divers">
                                <div class="form-group">
                                    <label *ngIf="newprest.acomptefocus || newprest.acomptefocus"> Acompte </label>
                                    <input type="number" step="0.01" class="form-control info" id="acompte"
                                        placeholder="Acompte" autofocus [(ngModel)]="newprest.acompte"
                                        (keyup.enter)="common.focusNext('.divers')"
                                        (focus)="newprest.acomptefocus = true;" (blur)="newprest.acomptefocus = false;"
                                        autocomplete="off">
                                </div>
                                <div class="form-group" *ngIf="showContrat && isPricipal">
                                    <label *ngIf="newprest.contratfocus || newprest.infoNextMouv  "> Contrat
                                    </label>
                                    <input type="text" class="form-control info" placeholder="Contrat" id="contrat"
                                        [(ngModel)]="newprest.numContrat" (keyup.enter)="common.focusNext('.divers')"
                                        (focus)="newprest.contratfocus = true;" (blur)="newprest.contratfocus = false;"
                                        autocomplete="off">
                                </div>
                            </div>

                            <div class="uppercase col-sm-12" style="margin: 80px 0px 0px;padding: 0;">
                                <button class="btn-ok" (click)="setValue(true, 'divers')">
                                    OK </button>
                                <label>Appuyez sur
                                    <b>Entrée</b> pour valider.</label>
                            </div>
                        </div>
                        <div *ngSwitchCase="11" class="etape8">
                            <div style="margin-bottom: 15px">
                                <span class="step-title" *ngIf="!newprest.showInfos"> Souhaitez vous ajouter des
                                    informations supplémentaires </span>
                                <span class="step-title" *ngIf="newprest.showInfos"> Informations supplémentaires
                                </span>
                            </div>
                            <div class="list-group" *ngIf="!newprest.showInfos">
                                <a class="list-group-item container" tabindex="0" (keyup)="changeFocus($event, i)"
                                    (click)="edit ? showLeft = !showLeft : generatePrestation();"
                                    (keyup.enter)="edit ? setValue('test', 'infosSupplementaire') : generatePrestation();">
                                    <input type="radio" id="s-option" name="showInfo" value="false"
                                        [checked]="newprest.showInfo === false">
                                    <span class="text">NON</span>
                                    <span class="checkmark"></span>
                                </a>
                                <a class="list-group-item container" tabindex="1" (keyup)="changeFocus($event, i)"
                                    (keyup.enter)="showInfoSupp(true)" (click)="showInfoSupp(true)">
                                    <input type="radio" id="s-option" name="showInfo" value="true"
                                        [checked]="newprest.showInfo === true">
                                    <span class="text">OUI</span>
                                    <span class="checkmark"></span>
                                </a>
                            </div>
                            <div *ngIf="newprest.showInfos">
                                <div class="form-group">
                                    <label *ngIf="newprest.infofactfocus || newprest.infoFact"> Infos fact </label>
                                    <input type="text" class="form-control info" id="autofocus" placeholder="Infos Fact"
                                        autofocus [(ngModel)]="newprest.infoFact"
                                        (keyup.enter)="common.focusElement('#infomvt')"
                                        (focus)="newprest.infofactfocus = true;"
                                        (blur)="newprest.infofactfocus = false;" autocomplete="off">
                                </div>
                                <div class="form-group">
                                    <label *ngIf="newprest.infomvtfocus || newprest.infoNextMouv  "> Infos prestation
                                    </label>
                                    <input type="text" class="form-control info" placeholder="Infos prestation"
                                        id="infomvt" [(ngModel)]="newprest.infoNextMouv"
                                        (keyup.enter)="common.focusElement('#infosup')"
                                        (focus)="newprest.infomvtfocus = true;" (blur)="newprest.infomvtfocus = false;"
                                        autocomplete="off">
                                </div>
                                <div class="form-group">
                                    <label *ngIf="newprest.infosuppfocus || newprest.infos"> Infos contenant </label>
                                    <textarea class="form-control" rows="{{countRowsInText(newprest.infos)}}"
                                        id="infosup" placeholder="Infos contenant" [(ngModel)]="newprest.infos"
                                        style="height: auto;" (focus)="newprest.infosuppfocus = true;"
                                        (blur)="newprest.infosuppfocus = false;" autocomplete="off"></textarea>
                                    <div class="uppercase" style="font-size: 11px; margin-top: 3px;"
                                        *ngIf="newprest.infosuppfocus">Taper
                                        sur TAB
                                        <span class="icontab">&#x21B9;</span> pour valider
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="uppercase col-sm-12" style="margin: 20px 0px;">
                                    <button class="btn-ok" (click)="generatePrestation();" [disabled]="isClicked">
                                        OK
                                    </button>
                                    <label style="margin-top:10px;"> Appuyez sur
                                        <b> Entrée </b> pour valider. </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-left uppercase btn-nav" *ngIf="!edit && !isModifierLeContenant" (click)="nextStep()"
                    style="position: absolute;">
                    <img src="assets/images/icons/fleche-suivant.svg" alt="suivant" /> Suivant
                </div>
            </div>
        </div>
    </div>
    <div id="slide-right">
        <div class="col-sm-12" style="margin-bottom:5px;">
            <button class="pull-left btn-close" *ngIf="showEditBtn" (click)="modifierLeContenant()"
                style="width: auto;"> Modifier le contenant </button>
            <div dropdown class="pull-left" style="padding: 0px" *ngIf="edit">
                <button type="submit" dropdownToggle class="pull-left btn-close">
                    ...
                </button>
                <ul *dropdownMenu class="dropdown-menu menuplus" role="menu" style="padding: 5px;">
                    <li role="menuitem">
                        <button class="bouton btn-simple" *ngIf="edit" (click)="testerImprimerBon()"> IMPRIMER
                        </button>
                    </li>
                    <li role="menuitem">
                        <button class="bouton btn-simple" *ngIf="edit" (click)="getToutesRsrcBSDDPlanningGeneral()">
                            IMPRIMER BSD
                        </button>
                    </li>

                </ul>
            </div>

            <button class="pull-right btn-close btn-valider" *ngIf="edit && isModifier" id="btnvalider" autofocus
                (click)="openModalConfirme()" (keydown.enter)="openModalConfirme()" [disabled]="isClicked">
                Valider </button>
            <button class="pull-right btn-close" id="closeSlide" (click)="hideFunction()"> Fermer </button>

        </div>
        <div class="col-sm-12">
            <h3 style="padding-left: 10px;font-size: 30px;font-weight: 300;font-family: Roboto-Light;"
                *ngIf="edit || newprest.showdate">
                {{( newprest.dateStart |
                date:'dd MMMM yyyy') }}</h3>
            <h3 style="padding-left: 13px; font-size: 24px;font-weight: 900;font-family: Roboto-Black;"
                *ngIf="edit && (newprest.listBon && newprest.listBon.length)">
                Bon N° <span *ngFor="let bon of newprest.listBon; let last = last;"> <span
                        *ngIf="bon.id === info.bonSelected.id">{{
                        !last ? bon.numBon :
                        bon.numBon }}</span> </span>
            </h3>
        </div>
        <div class="col-sm-12" style="height: calc(100% - 160px); overflow-y: auto; overflow-x: hidden;">
            <div class="col-sm-12" style="padding: 0">
                <div class="col-sm-6" *ngIf="newprest.client" style="cursor: pointer; padding-top: 6px;">
                    <label> Nom du client </label>
                    <div>
                        <div class="col-sm-12" style="padding-left: 0px;"> {{ newprest.client.libelleObjetEntite }}
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 pull-right" [ngClass]="{'div': !isVidage && !edit}" *ngIf="newprest.chantier"
                    (click)="!edit ? editEvent(newprest, 2) : false" style="cursor: pointer;">
                    <label> Nom du chantier </label>
                    <div>{{ newprest.chantier.numChantier }}</div>
                </div>

            </div>
            <div class="col-sm-12" style="padding: 0">
                <div class="col-sm-6">
                    <label *ngIf="newprest.client" class=" text-left uppercase text-underline showfiche"
                        (click)="showFiche()" style="margin-top: 7px;">
                        Voir la fiche
                    </label>
                </div>
                <div class="col-sm-6">
                    <label *ngIf="newprest.chantier" class=" text-left uppercase text-underline showfiche"
                        (click)="getChantier(newprest.chantier.id)">
                        Voir la fiche
                    </label>
                </div>
            </div>


            <div class="col-sm-12" [ngClass]="{'div': !isVidage && !edit}" *ngIf="newprest.adresse"
                (click)="!edit ? editEvent(newprest, 3) : false" style="cursor: pointer;">
                <label> Adresse </label>
                <div style="margin-bottom: 5px;">
                    {{ ((selectedChantier.numChantier|| "") +' - ' + (selectedChantier.adresse1 || "") +' - ' +
                    (selectedChantier.codePostal
                    || "") + ' ' + (selectedChantier.ville|| "") + (selectedChantier.telephone ? ' - ' +
                    selectedChantier.telephone:
                    '')) }}
                </div>
            </div>

            <div class="col-sm-12  {{ isVidage && isGroupe ? '' : 'div' }}"
                *ngIf="newprest.contenant && !newprest.tournee"
                (click)="edit ? modifContentContenant()  : editEvent(newprest, 6)"
                [ngClass]="{'disabledbutton': notEditable}">
                <label> Contenant </label>
                <div style="margin-bottom: 5px;">
                    <app-contenant [item]="newprest.contenant" [common]="common">
                    </app-contenant>
                </div>
            </div>
            <div class="col-sm-12  {{ isVidage && isGroupe ? '' : 'div' }}"
                *ngIf="newprest.contenant && newprest.tournee"
                (click)="edit ? editEvent(newprest, 5)  : editEvent(newprest, 6)"
                [ngClass]="{'disabledbutton': notEditable}">
                <label> Contenant </label>
                <div style="margin-bottom: 5px;">
                    <div *ngIf="newprest.tournee">
                        <div class="col-sm-1" style="padding: 0; width: 45px;" [ngStyle]="{'color': findCouleur()}">
                            <i class="fa fa-undo" aria-hidden="true"
                                style="font-size: 1.5em; padding-top: 4px;transform: rotate(145deg);"></i>
                        </div>
                        <div class="col-sm-11" style="padding: 0 0 0 15px;">
                            Tournée</div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 div" *ngIf="newprest.newBenne" [ngClass]="{'disabledbutton': notEditable}"
                (click)="edit ? modifContentContenant() : editEvent(newprest, 5)">
                <label> Contenant </label>
                <div style="margin-bottom: 5px;">
                    <app-contenant [item]="newprest.newBenne" [common]="common"></app-contenant>
                </div>
            </div>
            <div class="col-sm-6  {{ isVidage && isGroupe ? '' : 'div' }}" *ngIf="edit || newprest.exutoire"
                (click)="editEvent(newprest, 8)" [ngClass]="{'disabledbutton': notEditable}">
                <label> Exutoire </label>
                <div style="margin-bottom: 5px;">
                    {{ newprest.exutoire ? newprest.exutoire.libelleObjetEntite : '' }}
                </div>
            </div>
            <div class="col-sm-6" [ngClass]="{'div': !isVidage, 'disabledbutton': notEditable}"
                *ngIf="!isGroupe && (edit || newprest.typeOperation)" (click)="editEvent(newprest, 7)">
                <label> Opération </label>
                <div style="margin-bottom: 5px;" *ngIf="!isVidage">
                    {{ newprest.typeOperation ? newprest.typeOperation.libelleObjetEntite : '' }}
                </div>
                <div style="margin-bottom: 5px;" *ngIf="isVidage">
                    Contenant à vider
                    <div *ngIf="newprest.parking"> {{newprest.parking}} </div>
                </div>
            </div>
            <div class="col-sm-12" style="padding: 0">
                <div class="col-sm-6" [ngClass]="{'div': !isVidage, 'disabledbutton': notEditable}"
                    *ngIf="edit || (newprest.program || newprest.programation)" (click)="editEvent(newprest, 4)">
                    <label> Prestation programmée </label>
                    <div style="margin-bottom: 5px;">
                        {{ newprest.program ? 'OUI' : 'NON' }}
                    </div>
                </div>
            </div>

            <div class="col-sm-12" style=" padding: 0;" *ngIf="edit || newprest.showdate"
                [ngClass]="{'disabledbutton': notEditable}">
                <div class="col-sm-6  {{ isVidage && isGroupe ? '' : 'div' }}" (click)="editEvent(newprest, 4)">
                    <label> Date </label>
                    <div style="margin-bottom: 5px;"> {{ common.isDate(newprest.dateStart) }} </div>
                </div>
                <div class="col-sm-6  {{ isVidage && isGroupe ? '' : 'div' }}" (click)="editEvent(newprest, 4, 'h1')">
                    <label> Heure </label>
                    <div style="margin-bottom: 5px;"> {{ hourMvt() }}
                    </div>
                </div>
            </div>

            <div class="col-sm-12" style=" padding: 0;" *ngIf="societe.gestionDateMax && (edit || newprest.showdate)"
                [ngClass]="{'disabledbutton': notEditable}">
                <div class="col-sm-6  {{ (isVidage && isGroupe) || edit? '' : 'div' }}" (click)="editEvent(newprest, 4)">
                    <label> Date Max </label>
                    <div style="margin-bottom: 5px;"> {{ common.isDate(newprest.dateMaxStart) }} </div>
                </div>
            </div>

            <div class="col-sm-12" [ngClass]="{'div': !isVidage, 'disabledbutton': notEditable}"
                *ngIf="isShowSite && (edit || newprest.showdate)" (click)="editEvent(newprest, 9)">
                <label> Site </label>
                <div style="margin-bottom: 5px;">
                    {{ newprest.sitePrest ? newprest.sitePrest.nom || newprest.sitePrest.libelleObjetEntite : '' }}
                </div>
            </div>
            <div class="col-sm-12" style="padding: 0px" [ngClass]="{'disabledbutton': notEditable}">
                <div class="col-sm-6" [ngClass]="{'div': !isVidage}"
                    *ngIf="edit || (newprest.acompte && !newprest.acomptefocus)" (click)="editEvent(newprest, 10)">
                    <label> Acompte </label>
                    <div style="margin-bottom: 5px;">{{ common.toFixed(newprest.acompte) }}</div>
                </div>
                <div class="col-sm-6" [ngClass]="{'div': !isVidage}"
                    *ngIf="showContrat && isPricipal && (edit || (newprest.numContrat  && !newprest.contratfocus))"
                    (click)="editEvent(newprest, 10, '#contrat')">
                    <label> Contrat </label>
                    <div style="margin-bottom: 5px;"> {{ newprest.numContrat }} </div>
                </div>
            </div>
            <div class="col-sm-12" style="padding: 0px" [ngClass]="{'disabledbutton': notEditable}">
                <div class="col-sm-6" [ngClass]="{'div': !isVidage}"
                    *ngIf="edit || (newprest.numBonManuel && !newprest.numBonfocus)"
                    (click)="editEvent(newprest, 10, '#numbon')">
                    <label> N° de Bon manuel </label>
                    <div style="margin-bottom: 5px;"> {{ newprest.numBonManuel }} </div>
                </div>
                <div class="col-sm-6" [ngClass]="{'div': !isVidage}"
                    *ngIf="edit || (newprest.numBSDD && !newprest.numBSDDfocus)"
                    (click)="editEvent(newprest, 10, '#numbsdd')">
                    <label> N° de BSD manuel </label>
                    <div style="margin-bottom: 5px;">{{ newprest.numBSDD }}</div>
                </div>
            </div>
            <div class="col-sm-12" style="padding: 0px" [ngClass]="{'disabledbutton': notEditable}">
                <div class="col-sm-6  {{ isVidage && isGroupe ? '' : 'div' }}"
                    *ngIf="edit || (newprest.infoFact && !newprest.infofactfocus)" (click)="editEvent(newprest, 11)">
                    <label> Infos Fact </label>
                    <div style="margin-bottom: 5px;">{{ newprest.infoFact }}</div>
                </div>
                <div class="col-sm-6  {{ isVidage && isGroupe ? '' : 'div' }}"
                    *ngIf="edit || (newprest.infoNextMouv && !newprest.infomvtfocus)"
                    (click)="editEvent(newprest, 11, '#infomvt')">
                    <label> Infos prestation </label>
                    <div style="margin-bottom: 5px;"> {{ newprest.infoNextMouv }} </div>
                </div>
            </div>
            <div class="col-sm-12 {{ isVidage && isGroupe ? '' : 'div' }}" [ngClass]="{'disabledbutton': notEditable}"
                style="padding: 0px">
                <div class="col-sm-6" *ngIf="edit || (newprest.infos && !newprest.infosuppfocus)"
                    (click)="editEvent(newprest, 11, '#infosup')">
                    <label> Infos contenant </label>
                    <div style="margin-bottom: 5px;"> {{ newprest.infos }} </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 btn-foot">
            <button class="pull-left btn-close" id="log" *ngIf="edit" (click)="getLogs(newprest)">
                Logs </button>
            <button class="btn-close" id="supprimer" *ngIf="edit && !isPlanningLocked && !isHisto"
                (click)='initSupprimerBon()'>
                Supprimer </button>
        </div>
    </div>
    <div class="fiche" #fiche id="fiche"
        [ngStyle]="{'width': (showFichechantier || showFicheclt || isJourFerie || isSuspension || isClickFacturation || isProgrammation || isMouvSupp) ? '552px' : '0'}">
        <div class="ficheclt" *ngIf="showFichechantier" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
            <app-fiche-chantier [chantier]="showFichechantier" [client]="newprest.client" [edit]="isEditChantier"
                (hidefunction)="hideChantier()" (validefunction)="updateChantier($event)"
                (addfunction)="createChantier($event)" [add]="addChantier" [disablemodif]="edit"></app-fiche-chantier>
        </div>
        <div class="fichechantier" *ngIf="showFicheclt" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
            <app-fiche-client [position]="true" [client]="addClient ? '' : newprest.client.id"
                (hidefunction)="addClient ? showFicheCltadd() : showFiche()"
                (addfunction)="addClient ? afterAddClt($event) : false" [add]="addClient"></app-fiche-client>
        </div>
        <div class="ficheclt" *ngIf="isClickFacturation" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
            <app-location-facturation-devis [contenant]="contenantFact" [client]="client"
                (hidefunction)="showFacturation()" (validefunction)="saveLocationFact($event)">
            </app-location-facturation-devis>
        </div>
        <div class="ficheclt" *ngIf="isProgrammation" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
            <app-programmations [programme]="mouvBenneProgramme" (hidefunction)="showProgrammation()"
                (saveFerier)="saveJourFerier($event)" [module]="'ecocrm'" (saveSusp)="saveSuspension($event)"  (savePeriode)="mouvBenneProgramme = $event"></app-programmations>
        </div>
        <div class="ficheclt" *ngIf="isMouvSupp" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
            <app-plus-mouvement [newprest]="newprest" [groupId]="groupId || []" [article]="newprest.artDepot" [isShowSite]="isShowSite" [listMouvSupp]="newprest.listMouvSupp || []" (hidefunction)="showMouvPlus()"></app-plus-mouvement>
        </div>
    </div>
    <div *ngIf="isAddContTournee">
        <app-add-contenant-tournees [info]="detailTournee" (close)="toogleSlideTournee()"
            (updateFct)="addContenantTournee($event)">
        </app-add-contenant-tournees>
    </div>
</div>

<ng-template #changedate>
    <div class="modal-header">
        <h4 class="modal-title pull-left"> Raison report </h4>
        <button type="button" class="close pull-right" aria-label="Close"
            (click)="common.closeModal(); closeFunction();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="height: auto">
        <div class="col-sm-12">
            <div class="col-sm-12" style="padding: 0">
                <label for="from"> Raison report : </label>
                <textarea class="form-control" rows="3" [(ngModel)]="raisonReport"></textarea>
            </div>
        </div>
        <div class="text-right col-sm-12" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="updateDateWeek();"> Valider
            </button>
            <button type="button" class=" btn-close" (click)="common.closeModal(); closeFunction();"> Fermer </button>
        </div>
    </div>
</ng-template>


<ng-template #confirmeImpBonSansChauffeur>
    <div class="modal-header">
        <h4 class="modal-title pull-left"> Confirmation impression</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg">Il n'y a pas de chauffeur positionné sur le camion {{
                    immatriculationCamionSsChauffeur }}</label>
                <label class="cofirmemsg"> Souhaitez vous tout de même lancer l'impression ? </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="common.closeModal(); imprimerBon();"> OUI
            </button>
            <button type="button" class=" btn-close" (click)="common.closeModal()"> NON </button>
        </div>
    </div>
</ng-template>

<ng-template #programConfirme>
    <div class="modal-header">
        <h4 class="modal-title pull-left"> Confirmation </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg"> Vous êtes en train de modifier une prestation programmée. </label>
                <label class="cofirmemsg"> Voulez-vous appliquer les modifications sur toutes les prestations du
                    programme? </label>
                <label class="cofirmemsg"> Attention. Cette opération peut prendre plusieurs dizaines de secondes
                </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider"
                (click)="updateAll = true;common.closeModal(); saveMouvement();"> OUI
            </button>
            <button type="button" class=" btn-close" (click)="updateAll = false; common.closeModal(); saveMouvement();">
                NON </button>
        </div>
    </div>
</ng-template>

<ng-template #format>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Choix du format </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="height: auto">
        <div>
            <ul class="list-group listeformat" *ngIf="formatPerso.length">
                <li class="list-group-item" *ngFor="let item of formatPerso" (click)="formatprs = item"
                    [ngClass]="{'formatselected': formatprs.id === item.id}">
                    {{ item.libelleObjetEntite }}
                </li>
            </ul>

            <span *ngIf="!formatPerso.length"> Aucun format disponible. Veuillez en définir au moins un </span>

        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" *ngIf="!formatPerso.length"
                (click)="common.closeModal()">
                Fermer </button>
            <button type="button" class=" btn-close btn-valider" *ngIf="formatPerso.length" (click)="imprimerBon();">
                Valider </button>
            <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler </button>
        </div>
    </div>
</ng-template>

<ng-template #dialogueSuppression>
    <div class="modal-header">
        <h4 class="modal-title pull-left"> Motif de la suppression </h4>
        <button type="button" class="close pull-right" aria-label="Close"
            (click)="common.closeModal(); closeFunction();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="height: auto">
        <div class="col-sm-12">
            <div class="col-sm-12" style="padding: 0">
                <label for="from"> Veuillez saisir le motif de la suppression : </label>
                <textarea class="form-control" rows="3" [(ngModel)]="raisonSuppression"></textarea>
            </div>
        </div>
        <div class="text-right col-sm-12" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="supprimerBon();"> Ok
            </button>
            <button type="button" class=" btn-close" (click)="common.closeModal(); closeFunction();"> Annuler </button>
        </div>
    </div>
</ng-template>

<ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg"> {{ error }} </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="closeModalError()"> Fermer </button>
        </div>
    </div>
</ng-template>

<ng-template #msgFormat>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg"> {{ error }} </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();"> Fermer </button>
        </div>
    </div>
</ng-template>